/**
 * CoveragePopover
 * Tenant coverage cell with popover showing deployment details
 */

import React from 'react';
import {
  Text,
  Popover,
  PopoverTrigger,
  PopoverSurface,
} from '@fluentui/react-components';
import CoverageCell from '../../common/CoverageCell';
import { TenantDeployment } from '../types';

interface CoveragePopoverProps {
  deployedCount: number;
  totalCount: number;
  tenantDeployments: TenantDeployment[];
  getTenantNameById: (tenantId: string) => string;
}

export function CoveragePopover({
  deployedCount,
  totalCount,
  tenantDeployments,
  getTenantNameById,
}: CoveragePopoverProps) {
  const coveragePercent = totalCount > 0 ? Math.round((deployedCount / totalCount) * 100) : 0;
  
  const deployedTenants = tenantDeployments.filter(
    td => td.status === 'Deployed' || td.status === 'PartiallyDeployed'
  );
  const notDeployedTenants = tenantDeployments.filter(td => td.status === 'NotDeployed');

  return (
    <Popover withArrow>
      <PopoverTrigger disableButtonEnhancement>
        <div style={{ cursor: 'pointer' }}>
          <CoverageCell
            countLabel={`${deployedCount}/${totalCount}`}
            percent={coveragePercent}
            warnCount={0}
            warnNoun="policy"
            barMaxWidth={140}
          />
        </div>
      </PopoverTrigger>
      <PopoverSurface style={{ padding: 16, maxWidth: 320 }}>
        <div style={{ marginBottom: 12 }}>
          <Text style={{ fontWeight: 600, fontSize: 14, display: 'block', marginBottom: 8 }}>
            Tenant Coverage
          </Text>
          <Text style={{ fontSize: 12, color: '#6b7280' }}>
            {deployedCount} of {totalCount} tenants have this policy deployed
          </Text>
        </div>
        
        {deployedTenants.length > 0 && (
          <div style={{ marginBottom: 12 }}>
            <Text style={{ fontWeight: 600, fontSize: 12, color: '#107c10', display: 'block', marginBottom: 4 }}>
              ✓ Deployed ({deployedTenants.length})
            </Text>
            <ul style={{ margin: 0, paddingLeft: 16, fontSize: 12, color: '#444' }}>
              {deployedTenants.map(td => (
                <li key={td.tenantId} style={{ marginBottom: 2 }}>{getTenantNameById(td.tenantId)}</li>
              ))}
            </ul>
          </div>
        )}
        
        {notDeployedTenants.length > 0 && (
          <div>
            <Text style={{ fontWeight: 600, fontSize: 12, color: '#d13438', display: 'block', marginBottom: 4 }}>
              ✗ Not Deployed ({notDeployedTenants.length})
            </Text>
            <ul style={{ margin: 0, paddingLeft: 16, fontSize: 12, color: '#444' }}>
              {notDeployedTenants.map(td => (
                <li key={td.tenantId} style={{ marginBottom: 2 }}>{getTenantNameById(td.tenantId)}</li>
              ))}
            </ul>
          </div>
        )}
      </PopoverSurface>
    </Popover>
  );
}
